import { Typography } from '@material-ui/core';
import React from 'react';

import { PortHealthAlertData } from './utils';

export interface AlertDescriptionProps {
  alert: PortHealthAlertData;
}

export const AlertDescription: React.FC<AlertDescriptionProps> = ({ alert }) => (
  <>
    {alert.description}
    {alert.datetime && (
      <Typography component="div" variant="caption">
        {new Date(alert.datetime).toLocaleString()}
      </Typography>
    )}
  </>
);
